/**
 * Analytics Consent Component
 * Shows privacy-friendly consent banner
 */

import { useEffect, useState } from 'react';
import { analytics } from '../utils/analytics';

export function AnalyticsConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user already made a choice
    const hasOptedOut = analytics.hasOptedOut();
    const hasConsented = localStorage.getItem('analytics-consented');

    if (!hasOptedOut && !hasConsented) {
      // Show banner after 2 seconds
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('analytics-consented', 'true');
    analytics.optIn();
    setShowBanner(false);
  };

  const handleDecline = () => {
    analytics.optOut();
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 md:left-auto md:max-w-md">
      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-xl">
        <h3 className="mb-2 font-semibold text-gray-900">
          Privacy-Focused Analytics
        </h3>
        <p className="mb-4 text-sm text-gray-600">
          We use privacy-friendly analytics to improve WaySightAI. No personal
          data is collected, and your forecast data never leaves your browser.
        </p>
        <div className="flex gap-3">
          <button
            onClick={handleDecline}
            className="flex-1 rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="flex-1 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
          >
            Accept
          </button>
        </div>
        <p className="mt-2 text-xs text-gray-500">
          You can change this anytime in settings
        </p>
      </div>
    </div>
  );
}
